module.exports = __webpack_public_path__ + "img/about-fair-005@2x.944a50d2.jpg";